import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { defineSmartBannerImageSizeText } from '../../service/BannerHelpers/BannerHelpers';
import { Bem } from '../../service/Bem/Bem';
import { AdvType, BannerImage } from '../../typings/domain';
import { GridBannerImage } from '../GridBannerImage/GridBannerImage';

import './GridBannerImageAdvCell.css';
import * as keyset from './GridBannerImageAdvCell.i18n';

export interface GridBannerImageAdvCellProps {
    id: string;
    image: BannerImage;
    bannerType: AdvType;
    href?: string;
    isVideo?: boolean;
    onShowPreview?: () => void;
    additions?: React.ReactNode;
}

const i18n = i18nFactory(keyset);
const BLOCK = 'grid-banner-image-adv-cell';

export class GridBannerImageAdvCell extends React.PureComponent<GridBannerImageAdvCellProps> {
    private static renderName = (
        imageSizeText: string | undefined,
        name: string,
        bannerType: AdvType,
        duration?: string
    ) => {
        switch (bannerType) {
            case AdvType.CPM_AUDIO:
                return (
                    <div className={Bem.cls(BLOCK, 'name')}>
                        <span
                            className={Bem.cls(BLOCK, 'creative-name', {
                                'without-size': !imageSizeText
                            })}
                        >
                            {name}
                            {', '}
                        </span>
                        {duration && <span>{i18n('duration', { duration })}</span>}
                    </div>
                );
            default:
                return (
                    <div className={Bem.cls(BLOCK, 'name')}>
                        {imageSizeText && (
                            <>
                                <span>{imageSizeText}</span>
                                {', '}
                            </>
                        )}
                        <span
                            className={Bem.cls(BLOCK, 'creative-name', {
                                'without-size': !imageSizeText
                            })}
                        >
                            {name}
                        </span>
                    </div>
                );
        }
    };

    render() {
        const { id, image, onShowPreview, isVideo, bannerType, additions } = this.props;

        const { width, height, name, isAdaptive, duration } = image;

        const imageSizeText = isVideo
            ? undefined
            : isAdaptive
            ? i18n('adaptive-banner')
            : defineSmartBannerImageSizeText(width, height);

        return (
            <div className={Bem.cls(BLOCK)}>
                <GridBannerImage cls={Bem.cls(BLOCK, 'image')} image={image} onClick={onShowPreview} />

                <div className={Bem.cls(BLOCK, 'info')}>
                    {GridBannerImageAdvCell.renderName(imageSizeText, name, bannerType, duration)}

                    <div className={Bem.cls(BLOCK, 'id')}>{i18n('banner-id', { id })}</div>

                    {additions}
                </div>
            </div>
        );
    }
}
